import { BillingCreditsPhoneNumberUsage } from '@/components/billing/billing-credits-phone-number-usage';
import { useIsAdminOrManager } from '@/hooks/api/team';
import { useCreditsEnabled } from '@/hooks/api/use-billing-credits';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/usage')({
  component: UsageRoute,
});

function UsageRoute() {
  const { isAdminOrManager, isLoading: isRoleLoading } = useIsAdminOrManager();
  const { creditsEnabled, isLoading: isCreditsLoading } = useCreditsEnabled();

  if (!isCreditsLoading && !creditsEnabled) {
    return <Navigate to="/settings/numbers" replace />;
  }

  if (!isRoleLoading && !isAdminOrManager) {
    return <Navigate to="/settings/numbers" replace />;
  }

  return <BillingCreditsPhoneNumberUsage />;
}
